import React, {useEffect, useState} from 'react';

export const SardiusPlayer = (props) => {
    const {
        assetId,
        title,
    } = props;

    const [audioPlaying, setAudioPlaying] = useState(false)
    const [playerMediaSourceType, setPlayerMediaSourceType] = useState('');
    const [audioElement, setAudioElement] = useState(null);
    const [videoElement, setVideoElement] = useState(null);

    const getAudioElements = (player) => {
        return player.bitratesMenu.children().map((child) => {
            if (child.options.data.label.includes('Audio'))
                return child.el()
        }).filter(Boolean);
    }

    const getVideoElements = (player) => {
        return player.bitratesMenu.children().map((child) => {
            if (child.options.data.label.includes('Auto'))
                return child.el()
        }).filter(Boolean);
    }

    const playerCallback = (player) => {
        player.on('ready', function () {
            player.autoplay(false);
            player.muted(false);
            setPlayerMediaSourceType(player.currentType());
            if (player.currentType() === 'application/x-mpegURL') {
                const audioElements = getAudioElements(player);
                if (audioElements.length !== 0) {
                    setAudioElement(audioElements[0])
                }
                setVideoElement(getVideoElements(player)[0])
            }
        })
    }

    const toggleAudioVideo = () => {
        if (audioElement === null) {
            return;
        }
        if (videoElement === null) {
            return;
        }
        if (!audioPlaying) {
            audioElement.click()
            setAudioPlaying(true);
        } else {
            videoElement.click()
            setAudioPlaying(false);
        }
    }

    useEffect(() => {
        const player = sardiusPlayer(
            'sardiusPlayer',
            {
                assetUID: assetId,
                options: {
                    auto: false,
                    muted: false,
                },
            },
            playerCallback
        )

    }, [])

    return (
        <>
            <div className='aspect-video-padding aspect-video-padding-mobile -ml-3 -mt-3 -mr-3 -mb-2
                                sm:ml-0 sm:mr-0 sm:mt-0 sm:mb-0 sm:w-full'>
                <div className='absolute top-0 bottom-0 left-0 w-full h-full'>
                    <div id='sardiusPlayer'/>
                </div>
            </div>
            <div className='row mt-6 mb-4'>
                <div className='col-12'>
                    <div tabIndex='0'>
                        <h5 className='text-xs font-normal tracking-wide uppercase text-neutral-content'>Full
                            Sermon</h5>
                        <h1 className='text-2xl font-bold py-0 pr-12 min-h-auto'>
                            {title}
                        </h1>
                    </div>
                    <MediaTypeControl
                        sourceType={playerMediaSourceType}
                        audioElement={audioElement}
                        audioPlaying={audioPlaying}
                        handleToggle={toggleAudioVideo}/>
                    <a
                        href='/account/library'
                        className='inline-block mt-3 border-b-primary border-b b-solid leading-6 text-sm'
                    >
                        Back to Library
                    </a>
                </div>
            </div>
        </>
    )
}

const MediaTypeControl = (props) => {
    const {
        sourceType,
        audioElement,
        handleToggle,
        audioPlaying,
    } = props

    if(sourceType === 'audio/mpeg') {
        return (
            <div className='flex items-center py-2'>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.4532 11.2401V9.72656C18.4532 5.78798 15.3684 2.49047 11.5771 2.37609C9.62285 2.33087 7.80784 3.02868 6.42021 4.37641C5.73609 5.03549 5.19256 5.82631 4.82241 6.70118C4.45226 7.57604 4.26315 8.51682 4.2665 9.46676V11.2401C3.2885 11.2401 2.49316 12.0354 2.49316 13.0134V16.5601C2.49316 17.5381 3.2885 18.3334 4.2665 18.3334H6.03983V9.46676C6.03722 8.75432 6.17893 8.04873 6.45643 7.39254C6.73393 6.73636 7.14147 6.14318 7.65445 5.64878C8.16528 5.15151 8.77118 4.76242 9.43589 4.5048C10.1006 4.24717 10.8105 4.1263 11.523 4.14942C14.3674 4.23454 16.6798 6.73672 16.6798 9.72656V18.3334H18.4532C19.4312 18.3334 20.2265 17.5381 20.2265 16.5601V13.0134C20.2265 12.0354 19.4312 11.2401 18.4532 11.2401Z" fill="#06A8BD"/>
                    <path d="M6.92725 11.2402H8.70058V18.3336H6.92725V11.2402ZM14.0206 11.2402H15.7939V18.3336H14.0206V11.2402Z" fill="#06A8BD"/>
                </svg>
                <h5 className='leading-6 ml-2 text-[#06A8BD] font-bold text-primary'>Audio</h5>
            </div>
        )
    }

    if((sourceType === 'video/mp4') || (sourceType === 'application/x-mpegURL' && audioElement === null)) {
        return (
            <div className='flex items-center py-2'>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1997 1.69995C5.51281 1.69995 1.69971 5.51305 1.69971 10.2C1.69971 14.8869 5.51281 18.7 10.1997 18.7C14.8866 18.7 18.6997 14.8869 18.6997 10.2C18.6997 5.51305 14.8866 1.69995 10.1997 1.69995ZM10.1997 17C6.45036 17 3.39971 13.9493 3.39971 10.2C3.39971 6.4506 6.45036 3.39995 10.1997 3.39995C13.9491 3.39995 16.9997 6.4506 16.9997 10.2C16.9997 13.9493 13.9491 17 10.1997 17Z" fill="#06A8BD"/>
                    <path d="M7.6499 14.45L14.4499 10.2L7.6499 5.94995V14.45Z" fill="#06A8BD"/>
                </svg>
                <h5 className='leading-6 ml-2 text-[#06A8BD] font-bold text-primary'>Video</h5>
            </div>
        )
    }

    if(sourceType === 'application/x-mpegURL' && audioElement !== null) {
        return(
            <div className="my-4 flex w-max border border-solid border-[#06A8BD] rounded-lg">
                <button disabled={!audioPlaying} onClick={handleToggle} className={`flex items-center rounded-l ${audioPlaying ? '' : 'bg-[#06A8BD]'} mr-2 py-1 px-2`}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1997 1.69995C5.51281 1.69995 1.69971 5.51305 1.69971 10.2C1.69971 14.8869 5.51281 18.7 10.1997 18.7C14.8866 18.7 18.6997 14.8869 18.6997 10.2C18.6997 5.51305 14.8866 1.69995 10.1997 1.69995ZM10.1997 17C6.45036 17 3.39971 13.9493 3.39971 10.2C3.39971 6.4506 6.45036 3.39995 10.1997 3.39995C13.9491 3.39995 16.9997 6.4506 16.9997 10.2C16.9997 13.9493 13.9491 17 10.1997 17Z"
                              fill={`${!audioPlaying ? '#ffffff' : '#06A8BD'}`}/>
                        <path d="M7.6499 14.45L14.4499 10.2L7.6499 5.94995V14.45Z" fill={`${!audioPlaying ? '#ffffff' : '#06A8BD'}`}/>
                    </svg>
                    <span className={`leading-6 ml-2 text-[#06A8BD] font-bold ${!audioPlaying ? 'text-[#ffffff]' : 'text-[#06A8BD]'}`}>Watch</span>
                </button>
                <button disabled={audioPlaying} onClick={handleToggle} className={`flex items-center rounded-r ${!audioPlaying ? '' : 'bg-[#06A8BD]'} py-1 px-2`}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.4532 11.2401V9.72656C18.4532 5.78798 15.3684 2.49047 11.5771 2.37609C9.62285 2.33087 7.80784 3.02868 6.42021 4.37641C5.73609 5.03549 5.19256 5.82631 4.82241 6.70118C4.45226 7.57604 4.26315 8.51682 4.2665 9.46676V11.2401C3.2885 11.2401 2.49316 12.0354 2.49316 13.0134V16.5601C2.49316 17.5381 3.2885 18.3334 4.2665 18.3334H6.03983V9.46676C6.03722 8.75432 6.17893 8.04873 6.45643 7.39254C6.73393 6.73636 7.14147 6.14318 7.65445 5.64878C8.16528 5.15151 8.77118 4.76242 9.43589 4.5048C10.1006 4.24717 10.8105 4.1263 11.523 4.14942C14.3674 4.23454 16.6798 6.73672 16.6798 9.72656V18.3334H18.4532C19.4312 18.3334 20.2265 17.5381 20.2265 16.5601V13.0134C20.2265 12.0354 19.4312 11.2401 18.4532 11.2401Z" fill={`${audioPlaying ? '#ffffff' : '#06A8BD'}`}/>
                        <path d="M6.92725 11.2402H8.70058V18.3336H6.92725V11.2402ZM14.0206 11.2402H15.7939V18.3336H14.0206V11.2402Z" fill={`${audioPlaying ? '#ffffff' : '#06A8BD'}`}/>
                    </svg>
                    <span className={`leading-6 ml-2 text-[#06A8BD] font-bold ${audioPlaying ? 'text-[#ffffff]' : 'text-[#06A8BD]'}`}>Listen</span>
                </button>
            </div>
        )
    }

    return null;
}